module.exports = __webpack_public_path__ + "img/top_tray.png?c165fe505a8690df602303513e66d5b4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/icons/top_tray.png
// module id = 256
// module chunks = 0